import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronDown, Check } from "lucide-react";
import { switchLangPath } from "../lib/routes";
import { track, EVENTS } from "../lib/analytics";

export const LANG_NAMES = { en: "English", es: "Español", fr: "Français", de: "Deutsch", it: "Italiano", pt: "Português" };
export const LANG_ORDER = ["en", "es", "fr", "de", "it", "pt"];

export const LangSwitcher = ({ lang, dark = false, testid = "lang-switcher" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const pick = (l) => {
    setOpen(false);
    if (l === lang) return;
    track(EVENTS.LANGUAGE_CHANGED, { from: lang, to: l });
    navigate(switchLangPath(pathname, l));
  };

  return (
    <div ref={ref} className="relative" data-testid={testid}>
      <button data-testid={`${testid}-btn`} onClick={() => setOpen(!open)} aria-haspopup="listbox" aria-expanded={open} aria-label="Language"
        className={`flex items-center gap-1 px-1.5 py-1 text-xs font-medium uppercase transition-colors ${dark ? "text-white hover:text-white/70" : "text-[#050505] hover:text-black/60"}`}>
        {lang}
        <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul role="listbox" data-testid={`${testid}-menu`}
          className="absolute right-0 top-full z-[120] mt-2 w-40 overflow-hidden rounded-xl border border-black/8 bg-white py-1 shadow-xl">
          {LANG_ORDER.map((l) => (
            <li key={l}>
              <button data-testid={`${testid}-opt-${l}`} onClick={() => pick(l)} role="option" aria-selected={l === lang}
                className={`flex w-full items-center justify-between px-4 py-2 text-left text-sm font-light transition-colors hover:bg-black/[0.04] ${l === lang ? "font-medium text-[#0e7c6b]" : "text-[#2a2b29]"}`}>
                {LANG_NAMES[l]}
                {l === lang && <Check size={14} />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
